import { RootState } from "../store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import BreadcrumbService from "../../services/BreadcrumbsService";

const breadcrumbService = BreadcrumbService.instance;

export interface breadcrumbRoute {
  label: string;
  label_key?: string;
  path: string;
  id: string;
  value: any;
  index?: number;
}

export interface Breadcrumb {
  routeHistory: Array<any>;
  display: boolean;
}
const initialState: Breadcrumb = {
  routeHistory: [],
  display: false,
};

export const BreadcrumbSlice = createSlice({
  name: "breadcrumb",
  initialState,
  reducers: {
    updateBreadcrum: (state, action: PayloadAction<any>) => {
      if (!state.routeHistory.length || state.routeHistory.length === 0) {
        state = {
          routeHistory: [
            {
              ...action.payload.routeHistory[0],
              index: 0,
            },
          ],
          display: action.payload.display,
        };
      } else {
        const len = state.routeHistory.length;
        if (
          state.routeHistory[len - 1]?.id !== action.payload.routeHistory[0].id
        ) {
          state = {
            routeHistory: [
              ...state.routeHistory,
              { ...action.payload.routeHistory[0], index: len },
            ],
            display: action.payload.display,
          };
        } else if (
          state.routeHistory[len - 1]?.id === action.payload.routeHistory[0].id
        ) {
          state.routeHistory[len - 1] = { ...action.payload.routeHistory[0] };
        }
      }
      return state;
    },
    resetBreadcrumFrom: (state, action: PayloadAction<number>) => {
      const arr = [...state.routeHistory];
      state = {
        routeHistory: arr.splice(0, action.payload),
        display: true,
      };
      return state;
    },
    resetBreadcrum: state => {
      breadcrumbService.advancedSearch = null;
      state = initialState;
      return state;
    },
  },
});
export const { updateBreadcrum, resetBreadcrumFrom, resetBreadcrum } =
  BreadcrumbSlice.actions;
export const breadCrumbState = (state: RootState) => state.breadcrumb;
export default BreadcrumbSlice.reducer;
